<template>
  <!--Subscribe Newsletter-->
    <section class="subscribeNewsletter">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10 subscribeBox">
            <h1>Stay up to date with our latest news and product updates</h1>
            <p>Join our mailing list today and stay updated!</p>
            <form @submit.prevent="newsletterSubscribe" class="formInput">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label>Please introduce yourself?*</label>
                    <input type="text" required v-model="firstname" placeholder="Firstname" class="inputt">
                </div>
                <div class="col-md-6 mb-3">
                <label>LastName</label>
                  <input type="text" v-model="lastname" required placeholder="Lastname" class="inputt">
                </div>
                <div class="col-md-6 mb-3">
                    <label>How can we reach you? *</label>
                    <input v-model="email" type="email" required placeholder="Your email address" class="inputt">
                </div>
                <div class="col-md-6 mb-3">
                  <label>Are you a Buyer or Supplier? *</label>
                  <select v-model="group" required>
                    <option value="">Which option best describe you</option>
                    <option value="buyer">BUYER</option>
                    <option value="seller">SELER</option>
                  </select>
                </div>
                <div class="col-md-6 mb-3">
                    <label>Tell us about your business*</label>
                    <input type="text" v-model="company" required placeholder="Company Name*" class="inputt">
                </div>
                <div class="col-md-6 mb-3">
                    <label>Role/Position*</label>
                    <input type="text" v-model="role" required placeholder="Manager, CEO etc*" class="inputt">
                </div>
                <div class="col-md-12 mb-3">
                    <label>Where are you based out of?</label>
                    <select v-model="country" required>
                      <option value="">Please enter your country</option>
                      <option
                        v-for="(country, i) in countryList"
                        :value="country"
                        :key="i"
                      >
                        {{ country }}
                      </option>
                    </select>
                </div>
              </div>
              <div class="mt-4">
                <button type="submit">Subscribe</button>
              </div>


            </form>
          </div>
        </div>
      </div>
    </section>
  <!--Subscribe Newsletter Ends-->
</template>
<style scoped src="@/assets/css/styleFrontend.css"></style>
<style scoped src="@/assets/css/bootstrap.css"></style>
<script>
import axios from 'axios'
import Swal from 'sweetalert2';
import { API } from "@/util/APIroute";
import CountryList from "@/assets/countriesList.json"
export default {
  mounted(){
    window.scrollTo(0,0)
  },
  data(){
    return{
      countryList: CountryList.sort(),
      firstname: '',
      lastname: '',
      email: '',
      group: '',
      company: '',
      role: '',
      country: ''
    }
  },
  methods: {
    newsletterSubscribe(){
      const formData = {
        "email": this.email,
        "firstname": this.firstname,
        "lastname": this.lastname,
        "company": this.company,
        "country": this.country,
        "role": this.role,
        "group": this.group,
      }
      axios.post(`${API}/subscriber`, formData, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then((res) => {
        Swal.fire({
          title: "Done!",
          icon: 'success',
          text: `You have successfully subscribed to our newsletter`,
          showConfirmButton: true,
          timer: 3500
        })
        this.resetForm()
      })
      .catch(e => {
        console.log(e)
      })
    },
    resetForm(){
      this.email = ''
      this.firstname = ''
      this.lastname = ''
      this.group = ''
      this.company = ''
      this.role = '',
      this.country = ''
    }
  }
}
</script>
<style scoped>
.swal2-container.swal2-backdrop-show, .swal2-container.swal2-noanimation{
  z-index: 9999;
}
</style>
